import { render, staticRenderFns } from "./AudioInput.vue?vue&type=template&id=596d0460&"
import script from "./AudioInput.vue?vue&type=script&lang=ts&"
export * from "./AudioInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports